module.exports = __webpack_public_path__ + "static/media/sylwester24.d835f6fd.jpg";